import React, { Component } from "react"
import PropTypes from "prop-types"

import MDSpinner from "react-md-spinner"
import Arrow from "../icons/ArrowRight.svg?react"
import Edit from "../icons/Edit.svg?react"
import styles from "./Step.module.sass"
import { colors } from "component_library/styles/theme"

class Step extends Component {
  static propTypes = {
    id: PropTypes.string,
    appendedChildren: PropTypes.element,
    index: PropTypes.number.isRequired,
    active: PropTypes.bool,
    valueToLabelMapper: PropTypes.func,
    selected: PropTypes.any,
    completed: PropTypes.bool,
    loading: PropTypes.bool,
    impasse: PropTypes.bool,
    options: PropTypes.any,
    children: PropTypes.element,
    navigatedTo: PropTypes.func,
    headline: PropTypes.string,
    labels: PropTypes.object,
    stepName: PropTypes.string,
    valid: PropTypes.bool,
    validation: PropTypes.object,
    theme: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    nextStep: PropTypes.bool,
    onNextStepClick: PropTypes.func,
    hideStepsArrow: PropTypes.bool,
  }
  state = {}
  impasseMessage = this.props.labels.impasseMessage.replace(
    "%{input_name}",
    this.props.labels.inputNames[this.props.stepName]
  )

  constructor(props) {
    super(props)
    this.scrollAnchorRef = React.createRef()
    this.containerRef = React.createRef()
  }

  clickedWhenInactive = () => {
    this.props.navigatedTo(this.props.index)
  }

  scrollIntoView(opt) {
    this.scrollAnchorRef.current.scrollIntoView(opt)
  }

  scrollIntoViewIfNeeded(opt) {
    setTimeout(() => {
      if (!this.containerRef.current) return
      if (typeof IntersectionObserver === "function") {
        const io = new IntersectionObserver((entries) =>
          entries.forEach((entry) => {
            if (entry.intersectionRatio < 1) {
              this.scrollIntoView(opt)
            }
            io.unobserve(entry.target)
          })
        )
        io.observe(this.containerRef.current)
      } else {
        this.scrollIntoView(opt)
      }
    }, 300) // Scroll with delay to wait for animations and iframe height adjustments
  }

  renderValidation() {
    if (this.props.valid) return

    // Do not show validation message when the selected choice is not in options
    // To encourage people to choose again without looking like an error
    if (this.props.validation.ruleName === "valid") return

    let validationMessage =
      this.props.labels.validationMessages[this.props.validation.ruleName]
    if (validationMessage) {
      validationMessage = validationMessage.replace(
        /\{(\d+)\}/,
        (_s, index) => this.props.validation.values[parseInt(index)]
      )
    }
    return <p style={{ color: colors.red_500 }}>{validationMessage}</p>
  }

  render() {
    if (this.props.disabled) return null

    return (
      <div
        ref={this.containerRef}
        className={`${styles.container}`}
        id={this.props.id}
      >
        <div ref={this.scrollAnchorRef} className={styles.scrollAnchor} />
        {this.props.active ? (
          this.props.loading ? (
            <div className={styles.spinnerContainer}>
              <MDSpinner singleColor="#686868" />
            </div>
          ) : (
            <React.Fragment>
              {!this.props.hideStepsArrow && (
                <div className={styles.arrowIcon} style={{ top: "30px" }}>
                  <Arrow fill={this.props.theme.color} />
                </div>
              )}
              <div className={`${styles.activeContainer} dark-typography`}>
                <h2 className={styles.headline}>{this.props.headline}</h2>
                {this.props.options !== null && this.props.children}
                {this.renderValidation()}
                {this.props.impasse && (
                  <p style={{ color: colors.red_500 }}>{this.impasseMessage}</p>
                )}
              </div>
            </React.Fragment>
          )
        ) : this.props.completed ? (
          // Shows all the steps completed by the user or automatically
          // If the step is completed and user has passed it (active step > step index) then it is always shown
          <div tabIndex={0}
            role="button" className={styles.summarized} onClick={this.clickedWhenInactive} onKeyDown={(event) => {
              if (event.key === " " || event.key === "Enter") {
                this.clickedWhenInactive()
              }
            }}>
            {
              <React.Fragment>
                <Edit fill="#bbbbbb" />
                <span className={styles.summarizedText}>
                  {this.props.valueToLabelMapper(this.props.selected)}
                </span>
                <span className={`${styles.checked} ${styles.checkedRight}`} />
              </React.Fragment>
            }
          </div>
        ) : (
          <div
            className={styles.disabled}
            onClick={this.props.nextStep ? this.props.onNextStepClick : null}
          >
            {
              <React.Fragment>
                <span className={styles.summarizedText}>
                  {this.props.headline}
                </span>
              </React.Fragment>
            }
          </div>
        )}
        {this.props.appendedChildren && (
          <div className={styles.appendedChildren}>
            {this.props.appendedChildren}
          </div>
        )}
      </div>
    )
  }
}

export default Step
